// for environment
export enum EnvironmentOpt {
    Sandbox = 'Sandbox',
    Production = 'Production'
}

export const REGEX_SECURITY_WEBSITE_URL = String.raw`^(?:(https|HTTPS):\/\/(?:[a-zA-Z0-9-]{1,63}\.){0,5}[a-zA-Z0-9-]{1,63}\.[a-zA-Z]{2,63}(?:\/[a-zA-Z0-9\-._~:\/?#\[\]@!$&'()*+,;=%]*)?)$|^$`;